/**
 * IoT Shack Router
 * Routes for IoT device and gateway management
 */

import { Routes, Route, Navigate } from 'react-router-dom';
import FleetOverview from './FleetOverview';
import IoTOnboardDashboard from './IoTOnboardDashboard';
import ModelsCatalog from './ModelsCatalog';
import DevicesList from './DevicesList';
import DeviceDetailPage from './DeviceDetailPage';
import ModelDetailPage from './ModelDetailPage';
import GatewaysList from './GatewaysList';
import DecodersList from './DecodersList';
import IoTAgent from './IoTAgent';
import ListenersList from './ListenersList';
import DashboardsPage from './DashboardsPage';
import Playground from './Playground';
import MqttAbsentPage from './MqttAbsentPage';

export default function IoTRouter() {
  return (
    <div className="p-6">
      <Routes>
        <Route index element={<Navigate to="dashboard" replace />} />
        <Route path="dashboard" element={<FleetOverview />} />
        <Route path="onboard" element={<IoTOnboardDashboard />} />
        <Route path="models" element={<ModelsCatalog />} />
        <Route path="models/:id" element={<ModelDetailPage />} />
        <Route path="devices" element={<DevicesList />} />
        <Route path="devices/:id" element={<DeviceDetailPage />} />
        <Route path="gateways" element={<GatewaysList />} />
        <Route path="decoders" element={<DecodersList />} />
        <Route path="listeners" element={<ListenersList />} />
        <Route path="dashboards" element={<DashboardsPage />} />
        <Route path="playground" element={<Playground />} />
        <Route path="agent" element={<IoTAgent />} />
        <Route path="mqtt" element={<MqttAbsentPage />} />
        <Route path="*" element={<Navigate to="dashboard" replace />} />
      </Routes>
    </div>
  );
}

